import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC } from "react";
import NavigationSection from "@/components/NavigationSection";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import "rc-slider/assets/index.css";
import RangeSlider from "@/components/RangeSlider";
import { FloorSpaceFormField } from "@/consts/RangeSlider";
import useRangeSlider from "@/hooks/useRangeSlider";
import Link from "next/link";
import {
  FloorSpaceMax,
  FloorSpaceMin,
  FloorSpaceShortcuts,
  FloorSpaceStep,
  FloorSpaceUnit,
} from "@/consts/FloorSpace";

interface Props {
  query: ArchitectureSearchQueryParameter;
  queryController: SearchQueryParameterController<FloorSpaceFormField>;
}

const NavigationSectionFloorSpace: FC<Props> = ({
  query,
  queryController,
}): JSX.Element => {
  const rangeSlider = useRangeSlider({
    defaultMin: query.min_floor_space,
    defaultMax: query.max_floor_space,
    min: FloorSpaceMin,
    max: FloorSpaceMax,
    onUpdate: () => {
      queryController.addQuery("min_floor_space", rangeSlider.minQueryValue);
      queryController.addQuery("max_floor_space", rangeSlider.maxQueryValue);
      queryController.submitQuery();
    },
  });

  return (
    <NavigationSection
      title={`面積`}
      defaultOpen={!!query.min_floor_space || !!query.max_floor_space}
    >
      <div className="space-y-12">
        <div className="flex flex-col text-sm space-y-8">
          {FloorSpaceShortcuts.map((shortcut) => {
            return (
              <Link
                key={shortcut.label}
                href={queryController.toPath({
                  min_floor_space: shortcut.min ? String(shortcut.min) : null,
                  max_floor_space: shortcut.max ? String(shortcut.max) : null,
                })}
                prefetch={false}
              >
                {shortcut.label}
              </Link>
            );
          })}
        </div>
        <form onSubmit={rangeSlider.submitHandler}>
          <RangeSlider
            rangeSlider={rangeSlider}
            step={FloorSpaceStep}
            unit={FloorSpaceUnit}
          />
          <input type="submit" className="hidden" />
        </form>
      </div>
    </NavigationSection>
  );
};
export default NavigationSectionFloorSpace;
